import PageTitle from "~/library/PageTitle"
import LoadingWrapper from "~/library/LoadingWrapper"
import CatchCard from "~/library/CatchCard"
import CatchTable from "~/library/CatchTable"
import Pagination from "~/library/Pagination"
import NavigationLink from "~/library/NavigationLink"

import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import { apiLineItems } from "~/routes"
import LineItem from "~/types/LineItem"
import { formatCurrencyCents } from "~/utils/helpers"

const LineItemsList = () => {
  const { venueSlug } = getAppConfig()

  const sortingParams = {
    "q[s]": "created_at desc",
  }

  const {
    data: lineItems,
    refetch,
    metadata,
    isLoading,
  } = useFetchResource<{ lineItems: LineItem[] }, "lineItems">(
    apiLineItems.index.path({ venueSlug }),
    "lineItems",
    { page: "1", ...sortingParams }
  )

  const handlePageChange = (page: string) => {
    refetch({ page: page, ...sortingParams })
  }

  return (
    <LoadingWrapper isLoading={isLoading}>
      <PageTitle title="Line Items" newItemPath="/line-items/new" />

      <div className="row">
        <div className="col-12">
          <CatchCard className={"card-dark-theme"}>
            <CatchTable
              data={lineItems}
              emptyMessage="No Line Items"
              columns={[
                {
                  key: "name",
                  header: "Name",
                  formatter: (name, data) => (
                    <NavigationLink type="line-items" to={`/line-items/${data.id}`}>
                      {name}
                    </NavigationLink>
                  ),
                },
                {
                  key: "categoryName",
                  header: "Category",
                  formatter: (category) => category || "—",
                },
                {
                  key: "amountCents",
                  header: "Amount",
                  formatter: (amountCents) => formatCurrencyCents(amountCents),
                },
                {
                  key: "minOrderQty",
                  header: "Min Order Qty",
                  formatter: (minOrderQty) => minOrderQty || "—",
                },
                {
                  key: "active",
                  header: "Status",
                  formatter: (active) => (
                    <span className={`badge badge-lg ${active ? "bg-success" : "bg-secondary"}`}>
                      {active ? "Active" : "Inactive"}
                    </span>
                  ),
                },
              ]}
            />
            {metadata && (
              <Pagination
                metadata={metadata}
                onPageChange={(page: number) => handlePageChange(page.toString())}
              />
            )}
          </CatchCard>
        </div>
      </div>
    </LoadingWrapper>
  )
}

export default LineItemsList
